import { PropsWithChildren } from 'react';
import { UseQueryResult } from '@tanstack/react-query';

import { QueryTemplate } from '@components/base';

import GenericDataContext from './context';

type GenericDataContextProviderProps<T> = PropsWithChildren<{
  context: string;
  /** Keep content mounted through idle/loading/success transitions; errors still replace it. */
  preserveContentDuringLoad?: boolean;
  queryResult: UseQueryResult<T>;
}>;

function GenericDataContextProvider<T>({
  children,
  context,
  preserveContentDuringLoad = false,
  queryResult,
}: GenericDataContextProviderProps<T>) {
  if (preserveContentDuringLoad && !queryResult.error) {
    return (
      <GenericDataContext.Provider value={queryResult}>{children}</GenericDataContext.Provider>
    );
  }

  return (
    <QueryTemplate queryResult={{ ...queryResult, context }}>
      <GenericDataContext.Provider value={queryResult}>{children}</GenericDataContext.Provider>
    </QueryTemplate>
  );
}

export default GenericDataContextProvider;
